var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#233155;stroke-width:2px;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(32 48)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1,
    y: 1,
    width: 8,
    height: 7,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(44 63)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1,
    y: 1,
    width: 8,
    height: 7,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(32 59)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1,
    y: 1,
    width: 8,
    height: 11,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(44 48)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1,
    y: 1,
    width: 8,
    height: 11,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22);
export default __webpack_public_path__ + "static/media/Group 22.a6c531367d9bdc544b5b9e2d295ebe9f.svg";
export { ForwardRef as ReactComponent };